import React, { Fragment, useState } from 'react'
import { Tag } from 'antd';

// Images
import searchIcon from '@Images/icons/icon-search.png';
import Ai from '@Images/ai.png';

// Components
import H3Image from '../../../../../uilib/h3Image';
import H3Button, { defaultButtonTypes } from '../../../../../uilib/h3Button';

// Helpers
import Helpers from '@Apis/helpers';
import dayjs from 'dayjs';
import UserSavedFilterViewSelector from '../../../../Common/UserSavedFilterViewSelector';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum } from '../../../../../apis/constants';


const AccountPayableInvoiceListHeader = ({ user, keyword, searchKeyword, setSearchKeyword, history, setKeyword, filterState, dispatch, startDate, endDate, departments, setCurrentPage, pushParamsToUrl, refetch, handleApplyFilters, selectedFilterView, setSelectedFilterView, getFilterValueByKey, initialFilterValues, currentlyAppliedFilters, isUserReadyInitial, setIsUserReadyInitial, setSavedFilterViews, setSavedFilterViewsLoading, setIsUpdateFilterState, systemDefaultUserView, apInvoiceSelectedIntervalDateRangeType, setApInvoiceSelectedIntervalDateRangeType, setLimit, limit, setStartDate, setEndDate,
}) => {
  const {
    selectedTenant, selectedDepartment, selectedStatus, apinvoiceFromDueDate, apinvoiceToDueDate, paymentStatus, selectedTag,
  } = filterState;

  return (
    <Fragment>
      <div className="ant-col-md-24 ant-col-xs-24">
        <div className="doc-list__header-wrapper">
          <div className="doc-list__header-wrapper__left">
            <div className="section-search">
              <div className="doc-list__search-bar__wrapper">
                <div className="section-search-bar">
                  <input
                    value={keyword}
                    placeholder="Search for Accounts Payable Invoice..."
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        setSearchKeyword(e.target.value);
                        pushParamsToUrl({ currentKeyword: e.target.value, page: 1, currentLimit: 10, filterState, startDate, endDate });
                      }
                    }}
                    onChange={(event) => {
                      setKeyword(event.target.value);
                    }}
                  />
                  <H3Image
                    src={searchIcon}
                    className="section-search-bar__icon"
                    alt="search"
                    onClick={() => {
                      setSearchKeyword(keyword);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="doc-list__header-wrapper__right">
            {
              Helpers.getPermission(Helpers.permissionEntities.ACCOUNT_PAYABLE_INVOICE,
                Helpers.permissionTypes.CREATE, user)
              && user?.tenant_info?.purchase_config?.sub_modules?.account_payable_invoice?.settings?.is_enabled
              && (
                <div className="doc-list__buttons-wrapper">
                  <H3Button
                    buttonType={defaultButtonTypes.BLUE_ROUNDED}
                    text="+ New AP Invoice"
                    onClick={() => {
                      history.push('/purchase/account-payable-invoice/create');
                    }}
                    customClass="add-button"
                  />
                </div>
              )
            }
          </div>
        </div>
      </div>
      <div className="flex-align-c" style={{ gap: '10px' }}>
        <UserSavedFilterViewSelector
          selectedFilterView={selectedFilterView}
          onChangeTab={(currentSelectedView) => {
            setSelectedFilterView(() => {
              const currentSelectedViewFilters = currentSelectedView.filters;

              const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});
              const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false })?.date_range_type;

              let _orderStartDate = '';
              let _orderEndDate = '';

              if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                // No action needed for empty or custom date range type
              } else {
                const date = dateRangePresetsValues(_orderDateRangeType);
                const [start, end] = date;

                _orderStartDate = start;
                _orderEndDate = end;
                filterValue.from_date = _orderStartDate;
                filterValue.to_date = _orderEndDate;
              }

              filterValue.orderDateRangeType = _orderDateRangeType;

              const tempFilterValues = filterValue;
              setCurrentPage(1);
              setLimit(tempFilterValues.limit || limit);
              setSearchKeyword(tempFilterValues.keyword);
              setKeyword(tempFilterValues.keyword);
              setStartDate(tempFilterValues.from_date);
              setEndDate(tempFilterValues.to_date);
              setApInvoiceSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);

              dispatch({
                type: 'UPDATE_URL',
                payload: {
                  selectedTenant: tempFilterValues.tenant,
                  selectedDepartment: tempFilterValues.department_ids,
                  selectedStatus: tempFilterValues.status,
                  paymentStatus: tempFilterValues.payment_status,
                  selectedTag: tempFilterValues.label,
                },
              });

              pushParamsToUrl({
                currentKeyword: tempFilterValues.keyword,
                page: 1,
                currentLimit: tempFilterValues.limit || limit,
                filterState: {
                  selectedTenant: tempFilterValues.tenant,
                  selectedDepartment: tempFilterValues.department_ids,
                  selectedStatus: tempFilterValues.status,
                  paymentStatus: tempFilterValues.payment_status,
                  selectedTag: tempFilterValues.label,
                },
                startDate: tempFilterValues.from_date,
                endDate: tempFilterValues.to_date,
                apInvoiceSelectedIntervalDateRangeType: tempFilterValues.orderDateRangeType,
                selectedFilterView: currentSelectedView,
              });

              return currentSelectedView;
            });
          }}
          currentlyAppliedFilters={currentlyAppliedFilters}
          entityName={entityNameEnum.ACCOUNT_PAYABLE_INVOICE}
          setSavedFilterViews={(value) => setSavedFilterViews(value)}
          setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
          setIsUpdateFilterSate={(value) => setIsUpdateFilterState(value)}
          callback={() => {
            if (!isUserReadyInitial) setIsUserReadyInitial(true);
          }}
          systemDefaultUserView={systemDefaultUserView}
        />
        <div className="header__tags">
          {searchKeyword && (
            <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); pushParamsToUrl({ currentKeyword: '', page: 1, currentLimit: 10, filterState, startDate, endDate }); }} color="#2d7df7">
              Search results for -
              &nbsp;
              <span><b><i>{searchKeyword}</i></b></span>
            </Tag>
          )}
          {
            (startDate && endDate) ? (
              <Tag
                closable
                onClose={() => {
                  setStartDate(null);
                  setEndDate(null);
                  setCurrentPage(1);
                  pushParamsToUrl({ currentKeyword: searchKeyword, page: 1, currentLimit: 10, filterState, startDate: null, endDate: null });
                }}
                color="#2d7df7"
              >
                {' '}
                From:
                &nbsp;
                <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                &nbsp;
                To:
                &nbsp;
                <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
              </Tag>
            ) : ''
          }
          {selectedTenant && selectedTenant?.map((item) => (
            <Tag
              key={item}
              closable
              onClose={() => {
                setCurrentPage(1);
                dispatch({ type: 'SET_TENANT', payload: selectedTenant.filter((tId) => tId !== item) });
                pushParamsToUrl({ currentKeyword: searchKeyword, page: 1, currentLimit: 10, filterState: { ...filterState, selectedTenant: selectedTenant.filter((tId) => tId !== item) }, startDate, endDate });
                pushParamsToUrl({ currentKeyword: searchKeyword, page: 1, currentLimit: 10, filterState: { ...filterState, selectedTenant: selectedTenant.filter((tId) => tId !== item) }, startDate, endDate });
              }}
              color="#2d7df7"
            >
              Business Unit -
              &nbsp;
              <span>
                <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
              </span>
            </Tag>
          ))}
          {selectedDepartment && selectedDepartment?.map((item) => (
            <Tag
              key={item}
              closable
              onClose={() => {
                dispatch({ type: 'SET_DEPARTMENT', payload: selectedDepartment.filter((tId) => tId !== item) });
                setCurrentPage(1);
                pushParamsToUrl({ currentKeyword: searchKeyword, page: 1, currentLimit: 10, filterState: { ...filterState, selectedDepartment: selectedDepartment.filter((tId) => tId !== item) }, startDate, endDate });
              }}
              color="#2d7df7"
            >
              Department -
              &nbsp;
              <span>
                <b>{departments?.data?.result?.departments?.find((department) => department?.department_id == item)?.alias_name?.toUpperCase()}</b>
              </span>
            </Tag>
          ))}
          {selectedStatus && (
            <Tag closable onClose={() => { dispatch({ type: 'SET_STATUS', payload: null }); setCurrentPage(1); pushParamsToUrl({ currentKeyword: searchKeyword, page: 1, currentLimit: 10, filterState: { ...filterState, selectedStatus: null }, startDate, endDate }); }} color="#2d7df7">
              Status -
              &nbsp;
              <span><b>{selectedStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
            </Tag>
          )}
          {apinvoiceFromDueDate && apinvoiceToDueDate && (
            <Tag closable onClose={() => { dispatch({ type: 'SET_DUE_DATE', payload: null }); setCurrentPage(1); pushParamsToUrl({ currentKeyword: searchKeyword, page: 1, currentLimit: 10, filterState: { ...filterState, apinvoiceFromDueDate: null, apinvoiceToDueDate: null }, startDate, endDate }); }} color="#2d7df7">
              Due Date -
              &nbsp;
              <span><b>{apinvoiceFromDueDate?.format('DD/MM/YYYY')} - {apinvoiceToDueDate?.format('DD/MM/YYYY')}</b></span>
            </Tag>
          )}
          {paymentStatus && paymentStatus
            .filter((item) => item != null) // Filter out null and undefined values
            .map((item) => (
              <Tag
                key={item}
                closable
                onClose={() => {
                  setCurrentPage(1);
                  dispatch({ type: 'SET_PAYMENT_STATUS', payload: paymentStatus.filter((tId) => tId !== item) });
                  pushParamsToUrl({ currentKeyword: searchKeyword, page: 1, currentLimit: 10, filterState: { ...filterState, paymentStatus: paymentStatus.filter((tId) => tId !== item) }, startDate, endDate });
                }}
                color="#2d7df7"
              >
                Payment Status -
                &nbsp;
                <span>
                  <b>{String(item).split('_').join(' ').toUpperCase()}</b>
                </span>
              </Tag>
            ))}
          {selectedTag && selectedTag?.map((item) => (
            <Tag
              key={item}
              closable
              onClose={() => {
                dispatch({ type: 'SET_TAG', payload: selectedTag.filter((tId) => tId !== item) });
                setCurrentPage(1);
                pushParamsToUrl({ currentKeyword: searchKeyword, page: 1, currentLimit: 10, filterState: { ...filterState, selectedTag: selectedTag.filter((tId) => tId !== item) }, startDate, endDate });
              }}
              color="#2d7df7"
            >
              Label -
              &nbsp;
              <span>
                <b>{item?.toUpperCase()}</b>
              </span>
            </Tag>
          ))}
        </div>
      </div>
    </Fragment>
  )
}

export default AccountPayableInvoiceListHeader